
<!-- Esta es la base, aparecera con y sin redireccion -->
<router-outlet />
<!-- <nsc-loading /> -->
<nsc-toast-container />
